export default "__VITE_ASSET__qEmm_ZJu__"